import React from 'react';
import c from 'clsx';

import { formatNumberToDisplayPercentage } from '../../helpers';

import styles from './CategoryFilters.module.css';
import { TextLink, Typography } from '@repo/ui';

export interface CategoryFilterItem {
  key: string;
  color: string;
  name: string;
  value: number;
}

interface CategoryFiltersProps {
  displayableBacteriaCategories: CategoryFilterItem[];
  categoryFilters: string[];
  handleCategoryFilterClick: (categoryKey: string) => void;
  hiddenMetricsCount: number;
  handleClearFilters: () => void;
}

const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  displayableBacteriaCategories,
  categoryFilters,
  handleCategoryFilterClick,
  hiddenMetricsCount,
  handleClearFilters,
}) => {
  return (
    <div className={styles.categoryFiltersContainer}>
      {displayableBacteriaCategories.map(category => {
        const isActive = categoryFilters.includes(category.key);
        const dotColorClass = isActive
          ? styles[category.color.toLowerCase()]
          : styles[`${category.color.toLowerCase()}Light`];

        return (
          <button
            key={category.key}
            type='button'
            className={c(
              styles.categoryFilterButton,
              isActive
                ? styles.activeCategoryFilter
                : styles.inactiveCategoryFilter,
            )}
            onClick={() => handleCategoryFilterClick(category.key)}
            aria-pressed={isActive}
          >
            <span className={c(styles.filterDot, dotColorClass)} />
            <span className={styles.filterName}>{category.name}</span>
            <span className={styles.filterPercentage}>
              {formatNumberToDisplayPercentage(category.value)}
            </span>
          </button>
        );
      })}
      {hiddenMetricsCount > 0 && (
        <Typography variant='label' color='purple' className={'ml-2'}>
          {`${hiddenMetricsCount} hidden microbe${hiddenMetricsCount === 1 ? '' : 's'}`}
        </Typography>
      )}
      <TextLink
        label='Clear filters'
        onClick={handleClearFilters}
        iconNameLeft='closeSm'
        className={'ml-2'}
      />
    </div>
  );
};

export default CategoryFilters;
